import { SurveyResultsFilterNames } from '../models';
import { IFiltersToReset } from '../modules/admin-panel/pages/results/models';

export const isLocationChangedBetweenRounds = (
	filtersToReset?: IFiltersToReset,
) => {
	if (!filtersToReset) return false;

	const resetFiltersList = Object.keys(filtersToReset);
	return !!(
		resetFiltersList.includes(SurveyResultsFilterNames.office) ||
		resetFiltersList.includes(SurveyResultsFilterNames.city)
	);
};
